module.exports = "/img/5.5797a8.webp";